import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { PreloaderColor } from '@enums/shared.enum';
import { EnableEscCloseDirective } from '../../directives/enable-esc-close.directive';
import { NgIf } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { UiPreloaderComponent } from '../ui-preloader/ui-preloader.component';
import { UiButtonComponent } from '@ui';

export interface UiUniformUpdateNameDialogData {
  currentName: string;
  uniformId: string;
}

export interface UiUniformUpdateNameDialogResult {
  newName: string;
}

@Component({
  selector: 'app-ui-uniform-update-name-dialog',
  templateUrl: './ui-uniform-update-name-dialog.component.html',
  styleUrls: ['./ui-uniform-update-name-dialog.component.scss'],
  hostDirectives: [EnableEscCloseDirective],
  standalone: true,
  imports: [MatDialogClose, ReactiveFormsModule, NgIf, MatIcon, UiButtonComponent, UiPreloaderComponent],
})
export class UiUniformUpdateNameDialogComponent implements OnInit {
  public PreloaderColor = PreloaderColor;
  public loading = false;

  form = new FormGroup({
    name: new FormControl('', [Validators.required, Validators.minLength(1)]),
  });

  constructor(
    private dialogRef: MatDialogRef<UiUniformUpdateNameDialogComponent, UiUniformUpdateNameDialogResult>,
    @Inject(MAT_DIALOG_DATA) public data: UiUniformUpdateNameDialogData,
  ) {}

  ngOnInit(): void {
    // Pre-populate the form with current name
    this.form.patchValue({
      name: this.data.currentName,
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  save(): void {
    this.form.markAllAsTouched();
    if (this.form.invalid) {
      return;
    }

    const newName = this.form.get('name')?.value?.trim();

    // Only proceed if name actually changed
    if (newName === this.data.currentName) {
      this.dialogRef.close();
      return;
    }

    const result: UiUniformUpdateNameDialogResult = {
      newName: newName,
    };

    this.dialogRef.close(result);
  }
}
